<div>
  <div *ngIf="CanShow === 1 ">
    <div class="row ">
      <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12 my-profile-form padding-lr-0px">
        <div class="card-header wh-header card-header-bg padding-left-7px margin-top-10 padding-top-6px" *ngIf="CurrentActorIdentitiesController">
          <!--Drivers License/Passport-->
          <div class="row">
    <div class="col-md-10 pink">
      <i class="fa fa-id-card"></i> Drivers License/Passport
    </div>
    <div class="col-md-1 float-right" *ngIf="CanEdit === 1 " hidden >
      <a (click)="openNewContent()" class="nav-link-hand btn btn-primary">Upload</a>
    </div>
  </div>
        </div>
        <div class="card-body padding-all-0px margin-left-zero">
          <!--<div class="card-block">
    <div *ngFor="let l of CurrentActorIdentitiesController">
      <div class="media mb-1">
        <div class="media-body">
          <h4 class="font-medium-1 mt-1 mb-1">Expiration Date - {{l.ValidTo | date:'dd-MMM-yyyy'}}</h4>
          <p class="text-muted font-small-3 pink">{{l.CredentialType}}, {{l.IssuingAuthorityLongValue}}</p>
          <p class="text-muted font-small-2">{{l.CredentialNumber}}</p>
        </div>
        <div class="mt-1">
          <div class="row">
            <!--<div class="float-left">
            <a (click)="OpenDetailContent(l.ActorCredentialCode)" class="nav-link-hand">
              <span class="badge">
                <i class="fa fa-list grey"></i>
              </span>
            </a>
            <a (click)="openDocContent(l.ActorDocCode)" class="nav-link-hand">
              <span class="badge">
                <i class="fa fa-file grey"></i>
              </span>
            </a>
            <a (click)="del_(l.ActorCredentialCode)" *ngIf="CanEdit === 1 " class="nav-link-hand">
              <span class="badge">
                <i class="fa fa-times grey"></i>
              </span>
            </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>-->
          <div class="row">
            <div class="col-md-5">
              <div class="card margin-left-zero margin-right">
                <div class="card-header wh-header driver-header padding-left-7px font-weight-bold border-bottom">Drivers License</div>
                <div class="card-body padding-lr-0px  margin-left-zero padding-top-10px padding-bottom">
                  <div class="row" *ngIf="Dls">
                    <div *ngFor="let l of Dls" class="col-12">
                   
                      
                          
                            
                               <div class="row margin-left-zero">
                              <!--<div class="col-md-4 padding-left-7px">
                                <div class="form-group">
                                  <label>State</label>
                                  <span class="form-result"></span>
                                </div>
                              </div>-->
                              <div class="col-md-3" hidden>
                                <div class="form-group">
                                  <label>License #</label>
                                  
                                </div>
                              </div>
                              <div class="col-md-8">
                                <span class="form-result">
                                  {{l.CredentialNumber}},{{l.IssuingAuthorityLongValue}}

                                </span>
                              </div>
                              <div class="col-md-3 margin-lr-auto">
                                <a (click)="OpenEditDL(l)" class="nav-link-hand education-navlink margin-right-12px"><i class="fas fa-pencil-alt"></i></a>
                                <a (click)="openDocContent(l.ActorDocCode)" class="nav-link-hand education-navlink"><i class="fa fa-paperclip grey"></i></a>
                              </div>
                              <!--<div class="col-md-4">
                                <div class="form-group">
                                  <label>Validity</label>
                                  <span class="form-result">
                                    {{l.ValidFrom | date:'MMM-dd-yyyy'}} to <br />
                                    {{l.ValidTo | date:'MMM-dd-yyyy'}}
                                  </span>
                                </div>
                              </div>-->
                            </div>
                     <div class="row margin-left-zero">
                       <div class="col-md-3" hidden>
                         <div class="form-group">
                           <label>Validity</label>

                         </div>
                       </div>
                        <div class="col-md-8">
                          <span class="form-result">

                            valid Upto <a class="valid">{{l.ValidTo | date:'MMM-dd-yyyy'}}</a>

                          </span>
                              </div>
                     </div>
                          

                          <div class="row">
                            <div class="edit-tools">
                             
                              <a (click)="del_(l.ActorCredentialCode)" class="nav-link-hand education-navlink" *ngIf="CanEdit === 1" hidden>  <i class="fa fa-times grey"></i> </a>

                            </div>
                          </div>
                         
                       

                    </div>
                  </div>

                </div>

              </div>
            </div>
            <div class="col-md-5 margin-left-auto">
              <div class="card margin-left-zero margin-right">
                <div class="card-header wh-header driver-header padding-left-7px font-weight-bold border-bottom">Passport</div>
                <div class="card-body padding-lr-0px  margin-left-zero padding-top-10px padding-top-10px padding-bottom">
                  <div class="row">
                    <div *ngFor="let l of Pps" class="col-12">

                      <!--<div class="col-md-12 add-new-cerit">


    <div class="col-md-10 add-new-cerit ">
      <div class="row">

        <div class="col-md-4 padding-left-7px">
          <div class="form-group">
            <label>IssuingAuthority</label>
            <span class="form-result">{{l.IssuingAuthorityLongValue}}</span>
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group">
            <label>Passport Number</label>
            <span class="form-result">{{l.CredentialNumber}}</span>
          </div>
        </div>

        <div class="col-md-4">
          <div class="form-group">
            <label>Validity</label>
            <span class="form-result">
              {{l.ValidFrom | date:'MMM-dd-yyyy'}} to <br />
              {{l.ValidTo | date:'MMM-dd-yyyy'}}
            </span>
          </div>
        </div>


      </div>
      <div class="row">
        <div class="edit-tools">
          <a (click)="OpenEditPassport(l.ActorCredentialCode)" class="nav-link-hand education-navlink"><i class="fas fa-pencil-alt"></i></a>
          <a (click)="openDocContent(l.ActorDocCode)" class="nav-link-hand education-navlink"><i class="fa fa-file grey"></i></a>
          <a (click)="del_(l.ActorCredentialCode)" class="nav-link-hand education-navlink" *ngIf="CanEdit === 1" hidden>  <i class="fa fa-times grey"></i> </a>

        </div>
      </div>
    </div>
  </div>-->
                      <div class="row margin-left-zero">
                      
                        <div class="col-md-3" hidden>
                          <div class="form-group">
                            <label>#</label>

                          </div>
                        </div>
                        <div class="col-md-8">
                          <span class="form-result">
                            {{l.CredentialNumber}}, {{l.IssuingAuthorityLongValue}}

                          </span>
                        </div>
                        <div class="col-md-3 margin-lr-auto">
                          <a (click)="OpenEditPassport(l.ActorCredentialCode)" class="nav-link-hand education-navlink margin-right-12px"><i class="fas fa-pencil-alt"></i></a>
                          <a (click)="openDocContent(l.ActorDocCode)" class="nav-link-hand education-navlink"><i class="fa fa-paperclip grey"></i></a>
                        </div>
                      
                      </div>
                      <div class="row margin-left-zero">
                        <div class="col-md-3" hidden>
                          <div class="form-group">
                            <label>Validity</label>

                          </div>
                        </div>
                        <div class="col-md-8">
                          <span class="form-result">
                            valid Upto <a class="valid">{{l.ValidTo | date:'MMM-dd-yyyy'}}</a> 

                          </span>
                        </div>
                      </div>
                    </div>


                  </div>

                </div>

              </div>
            </div>
          </div>
       
        

        </div>
      </div>
      
      </div>
    </div>

 
  </div>

